import React from 'react';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { CustomIconSizeExpandingButton, IconContainer, StyledSearchIconContainer } from './styled';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';
import Button from '@atlaskit/button';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';

export interface Props {
    shown: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SearchButton = React.forwardRef(({ shown, onClick }: Props, ref: React.RefObject<HTMLButtonElement>) => {
    return (
        <>
            {isSearchEnhancementsMilestone1Enabled() ? (
                <StyledSearchIconContainer>
                    <Button
                        style={{ borderRadius: '50%' }}
                        ref={ref}
                        onClick={onClick}
                        appearance="subtle"
                        shouldFitContainer
                        iconBefore={
                            <SearchIcon size="medium" label="Search" primaryColor={token('color.icon', colors.N500)} />
                        }
                        analyticsContext={{ actionSubjectId: 'navbarSearch' }}
                    />
                </StyledSearchIconContainer>
            ) : (
                <IconContainer>
                    <CustomIconSizeExpandingButton expanded={shown} onClick={onClick} actionSubjectId="navbarSearch">
                        <SearchIcon size="medium" label="Search" primaryColor={token('color.icon', colors.N500)} />
                    </CustomIconSizeExpandingButton>
                </IconContainer>
            )}
        </>
    );
});

SearchButton.displayName = 'SearchButton';

export default SearchButton;
